<template>
    <ul class="orders-tabs">
        <li
            v-for="tab in tabs"
            :key="tab"
            class="orders-tabs__tab"
            :class="{ 'is-active': isActive(tab) }"
        >
            <slot :tab="tab">
                <button
                    class="button button--blank orders-tabs__button"
                    type="button"
                    @click="change(tab)"
                >
                    {{ tab }}
                </button>
            </slot>
        </li>
    </ul>
</template>

<script>
const tabsFilterMap = {
    active: {
        is_active: true,
        need_attention: false,
    },
    all: {
        is_active: false,
        need_attention: false,
    },
    need_attention: {
        need_attention: true,
        is_active: false,
    },
};

const getTabFilter = (tab) => tabsFilterMap[tab];

const containsFilter = (filters, tab) => {
    if (tab === 'all') {
        return !filters.is_active && !filters.need_attention;
    }

    const [[filter, value]] = Object.entries(getTabFilter(tab));

    return Object.entries(filters).some(([f, v]) => {
        return f === filter && v && value;
    });
};

export default {
    name: 'OrdersTabs',
    props: {
        filters: {
            type: Object,
            required: true,
        },
        tabs: {
            type: Array,
            required: true,
        },
    },
    emits: ['change'],
    methods: {
        isActive(tab) {
            return containsFilter(this.filters, tab);
        },
        change(tab) {
            this.$emit('change', getTabFilter(tab));
        },
    },
};
</script>

<style lang="scss" src="./OrdersTabs.scss"></style>
